import {i18n} from '@yourcoach/i18n';

import type {ProgramScheduleItemType} from './types';

interface ProgramScheduleItemTypeEnum {
  CONFERENCE: ProgramScheduleItemType;
  MATERIAL: ProgramScheduleItemType;
  TASK: ProgramScheduleItemType;
}

export const ProgramScheduleItemTypeEnum: ProgramScheduleItemTypeEnum = {
  CONFERENCE: {
    id: 'conference',
  },
  MATERIAL: {
    id: 'material',
  },
  TASK: {
    id: 'task',
  },
};

Object.keys(ProgramScheduleItemTypeEnum).forEach(key => {
  const type: ProgramScheduleItemType = ProgramScheduleItemTypeEnum[key];

  type.toString = () =>
    /**
     * @i18n_parser
     * t('shared:program.schedule_item_type.conference')
     * t('shared:program.schedule_item_type.material')
     * t('shared:program.schedule_item_type.task')
     */
    i18n.t(`shared:program.schedule_item_type.${type.id}`);
});
